import { render } from "./ButtonSettings.vue?vue&type=template&id=26ca862b&scoped=true"
import script from "./ButtonSettings.vue?vue&type=script&lang=js"
export * from "./ButtonSettings.vue?vue&type=script&lang=js"

import "./ButtonSettings.vue?vue&type=style&index=0&id=26ca862b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ca862b"]])

export default __exports__